module.exports = __webpack_public_path__ + "static/media/default_user_icon.30274720.jpg";